import { useCallback } from "react";

import type { OptionPmsItemCancelInput } from "@/lib/gql/__generated__/graphql";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import * as Repository from "../../../_repository";

type Props = {
	hotelID: string;
};

export const useCancelOptionPmsItem = ({ hotelID }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	/**
	 * オプションのキャンセル
	 */
	const { onCancelOptionPmsItem: _onCancelOptionPmsItem } =
		Repository.Mutation.UseCase.useOptionPmsItemCancelMutation();
	const onCancelOptionPmsItem = useCallback(
		async ({
			cardID,
			optionID,
			date,
			subOptionID,
		}: {
			cardID: string;
			optionID: string;
			date: string;
			subOptionID?: string;
		}) => {
			showLoadingScreenCallback();

			const input: OptionPmsItemCancelInput = {
				cardID,
				optionID,
				date,
				hotelID,
				subOptionID,
			} satisfies OptionPmsItemCancelInput;

			await _onCancelOptionPmsItem(input)
				.then(({ errors }) => {
					if (!errors) {
						notifyUserEventInfo({ variant: "default", title: "オプションをキャンセルしました" });
					}
				})
				.finally(() => hideLoadingScreenCallback());
		},
		[_onCancelOptionPmsItem, hideLoadingScreenCallback, hotelID, showLoadingScreenCallback],
	);

	return {
		// オプションのキャンセル
		onCancelOptionPmsItem,
	};
};
